import stylex from '@stylexjs/stylex';

import type { IContainerProps } from '~/components/utils/Container';
import { ListItem } from '../ListItem';

export type IListProps = IContainerProps & {
  children: React.ReactNode;
};

const styles = stylex.create({
  host: {
    listStyle: 'disc',
  },
});

const List: React.FC<IListProps> = (props) => {
  const { sx, children } = props;

  return <ul {...stylex.props(styles.host, sx)}>{children}</ul>;
};

const ListNamespace = Object.assign(List, {
  Item: ListItem,
});

export { ListNamespace as List };
